import { Injectable } from '@angular/core';
import swal from 'sweetalert2';

@Injectable()
export class SwalService {

  constructor() {
  }

  success(message) {
    swal.fire({
      type: 'success',
      title: 'HR PERF',
      text: message
    });
  }

  error(message) {
    swal.fire({
      type: 'error',
      title: 'HR PERF',
      text: message
    });
  }

}
